import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainWebsiteUrl } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-grid-line w-5 h-5 flex items-center justify-center text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {t("brand.name")}
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm text-foreground-700">{t("footer.tagline")}</p>
            <p className="mt-4 max-w-md text-xs text-foreground-600">{t("footer.disclaimer")}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t("footer.navTitle")}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/" className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer">
                  {t("footer.home")}
                </Link>
              </li>
              <li>
                <Link
                  to="/guide/usfans-spreadsheet-guide"
                  className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer"
                >
                  {t("footer.guide")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t("footer.resourcesTitle")}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={mainWebsiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-700 hover:text-primary-700"
                >
                  {t("footer.mainSite")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-secondary-200 pt-6">
          <p className="text-xs text-foreground-600">{t("footer.copyright")}</p>
          <a
            href={mainWebsiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-primary-700 hover:text-primary-800"
          >
            {t("footer.mainSite")} →
          </a>
        </div>
      </div>
    </footer>
  );
}